module.exports = __webpack_public_path__ + "static/media/banking_icon.ae17010a.svg";